import { ConditionMethods, QuestionMethods } from '../questionMethods.types';
import { CurrentQuestionMultiple } from './CurrentQuestionMultiple';
import {
	MultipleSelectGivenAnswer,
	RenderedMultipleSelectQuestion,
} from './multipleSelectMethods.types';
import { MultipleSelectCondition } from '@/globals/webApiTypes/elements/WebAPIDecisionToolData';
import { AnsweredQuestionMultiple } from './AnsweredQuestionMultiple';
import { isMultipleSelectAnswered } from './isMultipleSelectAnswered';
import { getMultipleSelectAnswerListItems } from './getMultipleSelectAnswerListItems';
import {
	addMultipleSelectToGivenAnswers,
	addMultipleSelectToSearchParams,
} from './addMultipleSelectToSearchParams';

export const MultipleSelectQuestionMethods: QuestionMethods<
	RenderedMultipleSelectQuestion,
	MultipleSelectGivenAnswer
> = {
	Current: CurrentQuestionMultiple,
	Answered: AnsweredQuestionMultiple,
	isAnswered: isMultipleSelectAnswered,
	getAnswerListItems: getMultipleSelectAnswerListItems,
	addToGivenAnswers: addMultipleSelectToGivenAnswers,
	addToSearchParams: addMultipleSelectToSearchParams,
};

export const MultipleSelectConditionMethods: ConditionMethods<MultipleSelectCondition> =
	{
		isMatch: ({ condition, givenAnswers }) => {
			const givenAnswer = givenAnswers.multiple.get(condition.questionId);
			if (givenAnswer == null) return true;

			return condition.answerIds.some((answerId) => givenAnswer.has(answerId));
		},
		isValid: (condition) => {
			return condition.answerIds.length > 0;
		},
	};
